<template lang="pug">
  div.mt-1
    div
      modal-editar-oficio(
        :documentoId="oficioAtual.id"
        v-if="showModalEditarOficio"
        :oficio="oficioAtual"
        titulo="Editar Ofício",
        @closeModal="closeModalEditarOficio"
        @onUpdatePDF="onUpdatePDF"
      )

      app-pdf-slider(
        v-if="bytes"
        :documentosBytes="arrayBytes"
        :primeiroDocumento="primeiroDocumento"
        @changePdfDownload="changePdfDownload"
      )

    div.mt-1
      el-button(
        @click="openModalEditarOficio")
        i.fal.fa-file-pdf
        span &nbsp Editar ofício
      el-button(
        @click="excluirCertidao")
        i.fal.fa-trash.red
        span &nbsp Excluir

</template>

<script>
import { mapActions } from 'vuex'
import AppPdfSlider from '@/components/AppPDFSlider.vue'
import ModalEditarOficio from '@/screens/arrecadacao/cpat/components/ModalEditarOficio'
import { stringToArrayBuffer } from '@/utils/utils'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    ModalEditarOficio,
    AppPdfSlider
  },

  props: {
    oficios: {
      required: true,
      type: Array
    }
  },

  mixins: [AppNotificacao],

  data () {
    return {
      bytes: null,
      arrayBytes: [],
      showModalEditarOficio: false,
      oficioAtual: null,
      idDocumentoSendoEditado: null
    }
  },

  computed: {
    primeiroDocumento () {
      if (this.idDocumentoSendoEditado) {
        return this.oficios.find(
          oficio => oficio.id === this.idDocumentoSendoEditado
        )
      }
      return this.oficioAtual
    }
  },

  created () {
    this.init()
  },

  methods: {
    ...mapActions({
      getAllCertidoesPdfsByOficiosIn:
        'oficioArrecadacao/getAllCertidoesPdfsByOficiosIn',
      deleteById: 'oficioArrecadacao/deleteById',
      deleteAllCertidoesNaoAssinadas:
        'oficioArrecadacao/deleteAllCertidoesNaoAssinadas'
    }),

    async init () {
      const certidoes = await this.getAllCertidoesPdfsByOficiosIn(
        this.oficios.map(({ id }) => id)
      )
      this.arrayBytes = certidoes.map(oficio => ({
        id: oficio.id,
        bytes: stringToArrayBuffer(oficio.bytes)
      }))
      this.oficioAtual = this.arrayBytes[0]
      this.bytes = this.arrayBytes[0].bytes
      this.$emit('getBytesPdf', this.bytes)
    },

    closeModalEditarOficio () {
      this.showModalEditarOficio = false
    },

    openModalEditarOficio () {
      this.showModalEditarOficio = true
    },

    changePdfDownload (documento) {
      this.bytes = documento.bytes
      this.oficioAtual = this.oficios.find(oficio => oficio.id === documento.id)
    },

    async onUpdatePDF () {
      this.idDocumentoSendoEditado = this.oficioAtual.id
      this.bytes = null
      this.closeModalEditarOficio()
      await this.init()
    },

    async excluirCertidao () {
      if (this.oficios.length > 1) {
        const oficios = this.oficios.filter(
          oficio => oficio.id !== this.oficioAtual.id
        )
        this.$emit('atualizarOficios', oficios)
        await this.deleteById(this.oficioAtual.id)
        this.bytes = null
        await this.init()
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          'Não é possivel apagar todas certidões'
        )
      }
    },
    deleteTodasCertidoesNaoAssinadas () {
      this.deleteAllCertidoesNaoAssinadas(this.oficios[0].processo.id)
    }
  }
}
</script>

<style lang="scss">
.red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/oficio/ConfirmarDados.vue